// extracted by mini-css-extract-plugin
module.exports = {"outer-row":"AccordionSection-module__outer-row__1Ripz"};